import React from 'react'
import { useField } from 'formik'
import isFunction from 'lodash/isFunction'
import MuiTextFieldWrapper from 'gui/components/common/MuiTextField'

const DefaultErrorComponent = ({ children }) => <div className="error">{children}</div>

/**
 * React Component
 * @param {Object} param0 The incoming object
 * @param {String} param0.label field label
 * @param {Object} param0.props the rest of the props
 * @param {Function} param0.props.updateLocalStore function to change the application redux store
 * @param {Function} param0.props.errorRenderProps component to render error
 */
export const InputFormik = ({ label, updateLocalStore, errorRenderProps, className, ...props }) => {
  const [field, meta] = useField(props)
  const { name, value, onChange, onBlur } = field
  const ErrorComponent = errorRenderProps || DefaultErrorComponent
  const hasError = meta.touched && meta.error

  // Ensure value is never null to prevent React warning
  const safeValue = value ?? ''

  return (
    <React.Fragment>
      <MuiTextFieldWrapper
        className={className || 'content-detail__input'}
        label={label}
        name={name}
        value={safeValue}
        onChange={(e) => {
          onChange(e)
          if (isFunction(updateLocalStore)) {
            updateLocalStore(e)
          }
        }}
        onBlur={(e) => {
          onBlur(e)
          if (isFunction(updateLocalStore)) {
            updateLocalStore(e)
          }
        }}
        error={hasError}
        helperText={hasError ? meta.error : ''}
        {...props}
      />
      {hasError && ErrorComponent !== DefaultErrorComponent && (
        <ErrorComponent>{meta.error}</ErrorComponent>
      )}
    </React.Fragment>
  )
}
